var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Step 3")]),_c('pre',[_vm._v("    "+_vm._s(_vm.items)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }